import React, { Component, Fragment } from 'react';
import { FormattedMessage } from "react-intl";

class PrimaryTraveller extends Component {
    render() {
        return <Fragment>
            <h2 className="form-title">
                <FormattedMessage id={this.props.name}/>
            </h2>
            <hr className="form-title-underline"/>
        </Fragment>
    }
}

export { PrimaryTraveller }
